export const PRIVATE = "private"
export const PUBLIC = "public"

export const WIDGET_SCOPES = { PRIVATE, PUBLIC }
